import './detect';

import Vue from 'vue';
import store from './store';
import router from './router';
import { sync } from 'vuex-router-sync';

import App from './App';

import i18n from '@shared/locale';
import _ from 'lodash';
import { trackView, trackEvent } from '@shared/userTracking/analytics';

import focus from '@shared/directives/focus';

Vue.config.productionTip = false;
// Load scripts before we bootstrap the application.

const makeGlobal = function(methods) {
    _.forOwn(methods, (method, methodName) => {
        // using Object.defineProperty to make the methods read only
        Object.defineProperty(Vue.prototype, `$${methodName}`, { value: method });
    });
};

// set vue instance methods
makeGlobal({ _, trackView, trackEvent });

/* eslint-disable no-new */
const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    directives: {
        focus,
    },
    render: (h) => h(App),
});

// sync the query params to the invoice vuex state
sync(store, router);

if (!window.Modernizr.flexbox) {
    document.body.classList.add('no-flex');
}

// set the lang attribute on the html element
document.documentElement.setAttribute('lang', app.$i18n.locale);

const trackPageView = (route) => {
    // get the local from the store as the user may have updated it
    let locale = app.$store.getters['locale/getLocale'];

    if (_.isUndefined(locale)) {
        locale = app.$i18n.locale;
    }

    // replace all . with _
    let page = _.replace(route.name, new RegExp('\\.', 'g'), '_');

    // track page view
    app.$trackView(page, locale);
};

router.afterEach((to, from) => {
    if (to.path != from.path) {
        trackPageView(to);
    }
});

window.onload = () => {
    trackPageView(app.$store.state.route);
};



// WEBPACK FOOTER //
// ./login/main.js